import { nanoid } from 'nanoid'
import { fetch } from '@/commons/fetch'
import { requestUrl } from '@/commons/config'

export const getUUID = async () => {
  const storageUUID = localStorage.getItem('UUID')
  if (storageUUID) {
    return storageUUID
  }

  let uuid = ''

  if (window.jsBridge && window.jsBridge.isApp) {
    const res = await window.jsBridge.getAppInfo()
    uuid = res.udid
  } else {
    uuid = nanoid()
  }

  localStorage.setItem('UUID', uuid)

  return uuid
}

export function report (params) {
  return new Promise(async (resolve, reject) => {
    const uuid = await getUUID()

    fetch({
      url: requestUrl.report,
      type: 'post',
      params,
      headers: {
        'x-version': '1.0.1',
        'x-app-id': 'GhustWIe32t7smS3',
        'x-udid': uuid
      },
      success: (datas) => {
        resolve(datas)
      }
    })
  })
}

/** 获取视频底部客服二维码配置 */
export function getServiceQRCode () {
  return new Promise(async (resolve, reject) => {
    fetch({
      url: ' https://common-open-api.jin10.com/configuration/getById',
      type: 'GET',
      headers: {
        'x-version': '1.0.0',
        'x-app-id': 'zP6WFH7WKz2vrw4Q'
      },
      params: {
        id: 1176
      },
      success: (datas) => {
        resolve(datas)
      }
    })
  })
}

export function getConfig (params) {
  return new Promise(async (resolve, reject) => {
    fetch({
      url: 'https://common-open-api.jin10.com/configuration/getById',
      type: 'GET',
      params,
      headers: {
        'x-version': '1.0.0',
        'x-app-id': 'zP6WFH7WKz2vrw4Q'
      },
      success: (datas) => {
        resolve(datas)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/apis/index.js